import React, { useEffect, useRef, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { FaCheckCircle, FaClock, FaTimesCircle, FaCheck, FaCopy } from 'react-icons/fa'
import CardsProgressSteps from '../../../../components/ProgressStep/CardsProgressSteps'
import { getFormattedAmount } from '../../../../actions/payments'
import '../../Transactions/transactions.css'
import Logo from '../../../../assets/img/Cardplot-dark.png';

function SendMoneySuccess() {
    const navigate = useNavigate()
    const location = useLocation()
    const { recipientName, amount, sendCurrency, totalAmount, status, transaction, sendMoneyOverview } = location.state || {};
    const isPayloadEmpty = !recipientName || !amount || !sendCurrency;

    useEffect(() => {
        if (isPayloadEmpty) {
            navigate("/user/send_money", { replace: true });
        }
    }, [isPayloadEmpty, navigate]);

    const handleDownloadReceipt = () => {
        const originalTitle = document.title;
        const txnId = transaction?.reference || transaction?.id || refId;
        document.title = `cardplot-reciepts-${txnId}`;
        window.print();
        setTimeout(() => {
            document.title = originalTitle;
        }, 1000);
    }
    
    const statusConfig = {
        outstanding: { icon: <FaCheckCircle />, class: 'status-completed', text: 'Successful' },
        completed: { icon: <FaCheckCircle />, class: 'status-completed', text: 'Successful' },
        pending: { icon: <FaClock />, class: 'status-pending', text: 'Pending' },
        failed: { icon: <FaTimesCircle />, class: 'status-failed', text: 'Failed' },
    };
    const currentStatus = statusConfig[transaction?.status] || statusConfig.pending;

    const receiptAmount = transaction ? new Intl.NumberFormat('en-NG', {
        style: 'currency',
        currency: transaction.wallet?.currency_code || sendCurrency,
    }).format(parseFloat(transaction.amount || amount)) : `${sendCurrency}${getFormattedAmount(totalAmount)}`;

    const refId = transaction?.reference || `TRX-${Date.now().toString().slice(-8)}`;
    const feeAmount = transaction?.fee !== undefined ? transaction.fee : (sendMoneyOverview?.appliedFees?.reduce((sum, f) => sum + f.amount, 0) || 0);
    const txDate = transaction?.created_at ? new Date(transaction.created_at) : new Date();

    return (
        <div>
            <div className="create__card__page send__money__page pt-2 no-print" >
                <section style={{ paddingTop: "50px" }}><CardsProgressSteps currentStep={4} stepLabels={["Recipient", "Amount", "Review", "Success"]} /></section>

                <div className='send__money__card mt-4 mx-auto text-center pb-4' style={{ maxWidth: '400px', padding: '30px', borderRadius: '20px' }}>
                    <FaCheckCircle size={80} color="green" className="mb-2 mt-4 d-flex justify-content-center mx-auto" />
                    <h3 className='mb-2'>Successful</h3>
        
                    <p className='auth__text'>
                        {status == 'successful' ? 
                            <> You have successfully sent money to <br /><b>{recipientName}</b></> : 
                            <> Your request to transfer money to <br /><b>{recipientName}</b> has been submitted successfully.</>
                        }
                    </p>

                    <h1 className='text-center my-2'>{sendCurrency}{getFormattedAmount(amount)}</h1>

                    {status == 'successful' &&
                        <button onClick={handleDownloadReceipt} className='btn btn-primary w-100 mt-4'>
                            Download receipt
                        </button>
                    }

                    <button onClick={() => navigate('/user/dashboard')} className='btn btn-outline-light text-dark w-100 mt-3'>
                        Return to Dashboard
                    </button>
                </div>
            </div>

            <div className="d-none d-print-block">
                <div className="receipt-card-modern" style={{ margin: '0 auto' }}>
                    <div className="receipt-top-bar"></div>
                    
                    <div className="receipt-header-modern d-flex justify-content-between align-items-center mb-4">
                        <div className="receipt-logo-modern">
                            <img src={Logo} alt="Cardplot" height="28" />
                        </div>
                        <div className="receipt-title-modern fw-bold text-muted" style={{ fontSize: '12px', letterSpacing: '1px' }}>PAYMENT RECEIPT</div>
                    </div>

                    <div className="receipt-amount-section text-center mb-4">
                        <div className="receipt-amount-label text-muted fw-bold mb-2" style={{ fontSize: '11px', letterSpacing: '1px' }}>AMOUNT PAID</div>
                        <div className="receipt-amount-value fw-bold mb-3" style={{ fontSize: '32px', color: 'var(--txn-primary)' }}>
                            {receiptAmount}
                        </div>
                        <div className="receipt-status-wrapper">
                            <span className="receipt-status-badge px-3 py-1 rounded text-capitalize" style={{ fontSize: '12px', backgroundColor: '#DCFCE7', color: '#10B981', fontWeight: '600' }}>
                                • {(transaction?.status == 'outstanding' || status == 'successful') ? 'Completed' : (transaction?.status || status)}
                            </span>
                        </div>
                    </div>

                    <div className="receipt-divider"></div>

                    <div className="receipt-details">
                        <div className="receipt-row d-flex flex-column flex-sm-row justify-content-between align-items-start gap-1 gap-sm-0">
                            <div className="receipt-label">Sender</div>
                            <div className="receipt-value text-start text-sm-end">
                                <div className="fw-bold text-uppercase" style={{ fontSize: '13px' }}>
                                    {transaction?.bank_transfer_details?.sender_account_name || transaction?.user?.full_name || 'Cardplot User'}
                                </div>
                                <div className="text-muted fw-normal" style={{ fontSize: '11px' }}>
                                    {transaction?.bank_transfer_details?.sender_bank_name || 'Cardplot'} 
                                </div>
                            </div>
                        </div>

                        <div className="receipt-row d-flex flex-column flex-sm-row justify-content-between align-items-start gap-1 gap-sm-0">
                            <div className="receipt-label">Recipient</div>
                            <div className="receipt-value text-start text-sm-end">
                                <div className="fw-bold text-uppercase" style={{ fontSize: '13px' }}>
                                    {recipientName}
                                </div>
                                <div className="text-muted fw-normal" style={{ fontSize: '11px' }}>
                                    {transaction?.bank_transfer_details?.bank_name || 'Cardplot'}
                                    {transaction?.bank_transfer_details?.account_number ? ` | ${transaction.bank_transfer_details.account_number}` : null}
                                </div>
                            </div>
                        </div>



                        <div className="receipt-row d-flex flex-column flex-sm-row justify-content-between align-items-start gap-1 gap-sm-0">
                            <div className="receipt-label">Transaction Type</div>
                            <div className="receipt-value fw-bold text-capitalize text-start text-sm-end" style={{ fontSize: '13px' }}>
                                Transfer
                            </div>
                        </div>

                        <div className="receipt-row d-flex flex-column flex-sm-row justify-content-between align-items-start gap-1 gap-sm-0">
                            <div className="receipt-label">Status</div>
                            <div className="receipt-value text-start text-sm-end">
                                <span className="px-3 py-1 rounded text-capitalize fw-bold" style={{ fontSize: '11px', backgroundColor: '#DCFCE7', color: '#10B981' }}>
                                    {(transaction?.status == 'outstanding' || status == 'successful') ? 'Completed' : (transaction?.status || status)}
                                </span>
                            </div>
                        </div>

                        {transaction?.metadata?.description && (
                            <div className="receipt-row d-flex flex-column flex-sm-row justify-content-between align-items-start gap-1 gap-sm-0">
                                <div className="receipt-label">Description</div>
                                <div className="receipt-value text-start text-sm-end fw-bold" style={{ fontSize: '13px' }}>{transaction.metadata.description}</div>
                            </div>
                        )}

                        <div className="receipt-row d-flex flex-column flex-sm-row justify-content-between align-items-start gap-1 gap-sm-0">
                            <div className="receipt-label">Date</div>
                            <div className="receipt-value fw-bold text-start text-sm-end" style={{ fontSize: '13px' }}>{txDate.toLocaleString('en-US', { month: 'short', day: 'numeric', year: 'numeric', hour: '2-digit', minute: '2-digit' })}</div>
                        </div>

                        <div className="receipt-row d-flex flex-column flex-sm-row justify-content-between align-items-start gap-1 gap-sm-0">
                            <div className="receipt-label">Reference ID</div>
                            <div className="receipt-value fw-bold text-start text-sm-end" style={{ fontSize: '13px' }}>
                                {refId}
                            </div>
                        </div>
                    </div>

                    <div className="receipt-footer-banner d-none d-print-block mt-3 p-2 text-center mb-3" style={{ backgroundColor: '#F8F5FF', color: '#1E1B4B', fontSize: '12px', borderRadius: '8px' }}>
                        <div className="fw-bold">Not on Cardplot yet? Download the app</div>
                        <div style={{ fontSize: '11px', color: '#475569' }}>connecting &amp; moving Africa's money.</div>
                    </div>
                    
                    <div className="receipt-footer-text d-none d-print-block text-center text-muted" style={{ fontSize: '10px', lineHeight: '1.6', maxWidth: '400px', margin: '0 auto' }}>
                        <p className="mb-1">©️ {new Date().getFullYear()} Cardplot Technologies Limited. All rights reserved.</p>
                        <p className="mb-1">Registered address: 10 Toyin Street, Ikeja City, Lagos State, Nigeria.</p>
                        <p className="mb-1">Cardplot®️ is a registered trademark of Cardplot Technologies Limited RC: 8144330.</p>
                        <p className="mb-0">All transactions are processed and monitored through regulated financial institutions and licensed bank partners. Deposits are safeguarded in line with applicable regulatory requirements.</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SendMoneySuccess;